import { Link } from 'react-router-dom';
import React, { memo } from 'react';
import he from 'he';

const InterestingNewsCard = memo((props) => {
    const { data,index,keyTarget ,more} = props;
     


    const rawUrl = data?.url_link ?? "";

// Safely extract part after .com
const url = rawUrl.includes('.com')
  ? rawUrl.substring(rawUrl.indexOf('.com') + 4)
  : "";

// Build final URL safely
let final_url = "#"; // fallback link

if (url) {
  final_url = url.includes('/tmdb')
    ? `https://www.teluguone.com${url}`
    : url.includes('/news')
      ? url.substring(url.indexOf('/news') + 5)
      : "#";
}

const imageSrc =
  data?.stimg || `${import.meta.env.BASE_URL}assets/images/error_img.webp`;

const title = data?.title ? he.decode(data.title) : "";

return (
  <div className='container-fluid interesting-news-card g-0'>
    <div className='row ps-0 g-0'>
      <div className='col-12 col-sm-5 intresting-news-img-container'>
        <Link to={final_url} target={keyTarget} rel='noreferrer'>
          <img
            loading={(index <= 2 && more === "more") ? 'eager' : 'lazy'}
            fetchpriority={(index === 0 && more === "more") ? 'high' : 'auto'}
            src={imageSrc}
            alt="intnews-img"
            className='int-news-img'
          />
        </Link>
      </div>
      <div className='col-12 col-sm-7 d-flex align-items-center int-news-title-container'>
        <Link to={final_url} style={{ textDecoration: "none" }} target={keyTarget} rel='noreferrer'>
          <h4
            className='int-news-title'
            dangerouslySetInnerHTML={{ __html: title }}
          ></h4>
        </Link>
      </div>
    </div>
  </div>
);
});

export default InterestingNewsCard;
